var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithinThresholdOnQuant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.667 100L166.666 633.333L700 633.333V700H100V100H166.667ZM554.376 243.291L697.609 375.507L652.391 424.493L578.933 356.7L512.358 514.881L408.833 420L319.788 583.333H200V516.667H280.2L391.13 313.317L487.633 401.767L554.376 243.291ZM300 166.667V233.333H233.333V166.667H300ZM433.333 166.667V233.333H366.667V166.667H433.333ZM566.667 166.667V233.333H500V166.667H566.667ZM700 166.667V233.333H633.333V166.667H700Z",
    fill: "#011d89"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 552,
    width: 67,
    height: 67,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 552,
    width: 67,
    height: 67,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 551,
    width: 67,
    height: 68,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 633,
    y: 551,
    width: 67,
    height: 68,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithinThresholdOnQuant);
export default __webpack_public_path__ + "static/media/within-threshold-on-quant.cc7afdfb7d8bd44a2d1e2d3a2ce112fb.svg";
export { ForwardRef as ReactComponent };